// extracted by mini-css-extract-plugin
export var buttons = "survey-question-edit-module--buttons--qBV+R";
export var container = "survey-question-edit-module--container--JbLBE";